import * as React from "react";
import { AuthProvider } from "./authContext";

function AppProviders({ children }: any) {
  return <AuthProvider>{children}</AuthProvider>;
}

export default AppProviders;
